import React from "react";
import { Link } from "react-router-dom";

import { makeStyles, withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import logo from "@assets/images/lr-login-logo.png";
import { useStyles } from "./styles";
const styles = makeStyles(useStyles);
const LRIntegrationHeader = React.memo(({children,headerLogo=false,footerClass=''}) => {
  const classes = styles();
  return (<>
    <div className={classes.contentContainer}>
      {headerLogo &&<Grid container className={`${classes.registrationHeaderWrapper} lr-logo`}>
        <Grid xs={12} sm={12} md={12} lg={12} className={classes.logoContainer}>
          <h1>
            <Link to="/">
              <img src={logo} alt="Niram Healthcare" />
            </Link>
          </h1>
        </Grid>
      </Grid> }
      {children}
    </div>
    </>
  );
});

export default LRIntegrationHeader;
